module.exports = __webpack_public_path__ + "img/kj_ico1.5d9811c6.png";